<template>
    <div class="all">
        <div class="container">
            <div class="grid h-auto">
                <div class="grid-header">
                    <h2 class="title">传播路径</h2>
                </div>
                <div class="grid-body mt20">
                    <div class="path-warp" :style="treeH != 0 &&  timeType === 1? {height:''+treeH+'px'} : ''">
                        <div class="chart-tab">
                            <div class="corm fl">
                                <a class="element" :class="{curr:timeType===1}" href="javascript:void(0)" @click="selectChart(1);">树状图</a>
                                <a class="element" :class="{curr:timeType===0}" href="javascript:void(0)" @click="selectChart(0);">关系图</a>
                            </div>
                        </div>
                        <pathChart id="pathChart" :dataArray="pathData" v-if="pathData != '' && timeType === 0"></pathChart>
                        <treeChart id="treeChart" :dataArray="pathData1" v-if="pathData1 != '' && timeType === 1"></treeChart>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import pathChart from '../../components/echart/pathChart.vue';
import treeChart from '../../components/echart/treeChart.vue';
export default {
    components:{pathChart,treeChart},
    data() {
        return {
            planId:'',
            timeType:1,
            pathData:[],
            treeH:0,
            pathData1:[],
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getPathData();
        }) 
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 获取传播路径数据
        getPathData () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.get('monitor/analysis/propagate-path', {sid:that.planId,simHash:that.$route.query.simHash,newId:that.$route.query.id}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.pathData = r.data;
                });
            })
            that.$api.get('monitor/analysis/tree-path', {sid:that.planId,simHash:that.$route.query.simHash,newId:that.$route.query.id}, r => {
                that.$utils.returnCode(r,function(){
                    that.pathData1 = r.data;
                    let h = 0;
                    for(let i in that.pathData1.children){
                        for(let k in that.pathData1.children[i].children){
                            h+=15;
                        }
                    }
                    if(h > 900){
                        that.treeH = h;
                    }
                });
            })
            
        },
        // 选择图标
        selectChart (type) {
            this.timeType = type;
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/propagationPath.vue